module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_facebook-1eaa5cc66118a478000fa8d1eefbdfb2.svg";